import React from 'react'
import './Skills.css'

function Skills() {
    return (
        <div id='skills' className='skills-section'>
            <h2>Technology Skills</h2>
            <div className="skills">
                <img src="./photos/skills-img-2.png" alt="Skills" />
            </div>
        </div>
    )
}

export default Skills
